import { Injectable, inject } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { finalize, map, startWith, switchMap, withLatestFrom } from 'rxjs/operators';

import { CropYearChanged, SetDefaultCropYear } from 'src/app/store/actions';
import { getCropYear } from 'src/app/store/selectors';

import * as SalesOrderPeriodActions from './sales-order-period.actions';
import { PeriodType, SalesOrderPeriodState } from '../models/sales-order-period.models';
import { SalesOrderPeriodApiService } from '../services/sales-order-period-api.service';

@Injectable()
export class SalesOrderPeriodEffects {
  protected store = inject<Store<SalesOrderPeriodState>>(Store);
  protected actions$ = inject(Actions);
  private readonly api = inject(SalesOrderPeriodApiService);

  getSalesOrderPeriods$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SetDefaultCropYear, CropYearChanged),
      withLatestFrom(this.store.select(getCropYear)),
      switchMap(([_, cropYear]) =>
        this.api.getSalesOrderPeriods(cropYear, PeriodType.Fertilization).pipe(
          map((salesOrderPeriods) =>
            SalesOrderPeriodActions.setSalesOrderPeriods({
              salesOrderPeriods,
            }),
          ),
          startWith(CoreActions.setLoading({ loading: true })),
          finalize(() => this.store.dispatch(CoreActions.setLoading({ loading: false }))),
        ),
      ),
    ),
  );
}
